import { z } from 'zod';
/** Calendar planning metadata, independent of due dates and capacity forecasts. */
export const TargetQuarter = z.string().length(7).regex(/^[2-9]\d{3}-Q[1-4]$/, 'Use a quarter such as 2027-Q1');
export const TicketQuarterPlanning = z.object({
    effectiveQuarter: TargetQuarter.nullable(),
    parentQuarter: TargetQuarter.nullable(),
    parentSource: z.object({ id: z.string(), code: z.string(), type: z.string() }).nullable(),
});
export function targetQuarterLabel(value) {
    const [year, quarter] = value.split('-');
    return `${quarter} ${year}`;
}
//# sourceMappingURL=target-quarter.js.map